import React, { Component } from 'react';
import LoadingComponent from '../../components/inc/LoadingComponent';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import Button from 'components/CustomButtons/Button.jsx';
import styles from 'assets/jss/customStyle.jsx';
import MainPage from 'assets/jss/MainPageStyle.jsx';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Footer from 'components/Footer/Footer.jsx';
import NavigationBar from 'components/inc/NavigationBar.jsx';
import ContractList from '../../components/SprintList/ContractList';
import { Container } from '@material-ui/core';

class SprintContractsPage extends Component {
  state = {
    // placeholder
    loading: true,
  };
  componentDidMount() {
    // loading placeholder
    setTimeout(() => this.setState({ loading: false }), 1000);
  }
  render() {
    const { classes } = this.props;

    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <LoadingComponent isLoading={this.state.loading}>
            <Breadcrumbs style={{ margin: '20px 0px' }} aria-label='breadcrumb'>
              <Typography style={{ color: '#4caf50' }}>ACP</Typography>
              <Typography style={{ color: '#4caf50' }}>
                ACP Beta sprint 2
              </Typography>
            </Breadcrumbs>
            <div style={{ float: 'right' }}>
              <Link to={'#'}>
                <Button type='button' color='success' round>
                  Bid(4)
                </Button>
              </Link>
              <Link to={'/#'}>
                <Button type='button' round>
                  Dev(1)
                </Button>
              </Link>
              <Link to={'#'}>
                <Button type='button' round>
                  Acceptance(15)
                </Button>
              </Link>
            </div>
            <Clearfix />
            <ContractList />
            <div className={classes.left} style={styles.marginTopBottom}>
              <Link to='#'>
                <Button type='button' color='success' round>
                  Back
                </Button>
              </Link>
            </div>
            <Clearfix />
          </LoadingComponent>
        </Container>
      </main>
    );
  }
}

export default withStyles(MainPage)(SprintContractsPage);
